export default () => ({
  offers: {},
  loading: false,
  filters: {},
})
